import { Box, Button, Image, Input, Text } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import QRCode from 'qrcode';




export const Generator = () => {
    const [url, setUrl] = useState('https://www.google.co.in/');
    const [generatedQRCode, setGeneratedQRCode] = useState(null);

    const generateQRCode = async () => {
        try {
            const qrCodeDataUrl = await QRCode.toDataURL(url);
            setGeneratedQRCode(qrCodeDataUrl);
        } catch (error) {
            console.error('Error generating QR code:', error);
        }
    };

    useEffect(() => {
        generateQRCode()
    }, [])

    return (
        <Box bg={'#1E1E1E'} p={'10px'} borderRadius={'15px'}>
            {generatedQRCode && (<Box><Image minW={'200px'} display={'block'} m={'10px auto'} src={generatedQRCode} alt="QR Code" /></Box>)}
            {/* <label htmlFor="urlInput">Enter URL:</label> */}
            <Input  w={['95%','80%','70%']} m={'auto'} display={'block'} color={'#E0E0E0'} border={'1px solid #E0E0E0'} textAlign={'center'} type="text" id="urlInput" placeholder="https://example.com" value={url} onChange={(e) => setUrl(e.target.value)} />
            <Button bg={'#00E676'} color={'#000544'} w={'50%'} minW={'200px'} display={'block'} m={'10px auto'} onClick={generateQRCode}>Generate QR Code</Button>
        </Box>
    )
}